/// <reference types="@wix/yoshi-flow-library/types" />

declare namespace JSX {
  interface IntrinsicElements {
    'wow-image': any;
  }
}
